import { Component, MouseEvent, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon, ListItemIcon, MenuItem, Theme } from '@mui/material';
import { WithStyles, createStyles, withStyles } from '@mui/styles';
import ChevronRight from '@mui/icons-material/ChevronRight';

import { PoolTypography } from '../typography/pool-typography';

const styles = (theme: Theme) =>
    createStyles({
        menuItemIcon: {
            fontSize: '16px',
            color: theme.palette.text.primary,
        },
        chevron: {
            position: 'absolute',
            right: theme.spacing(1),
        },
        iconRight: {
            position: 'absolute',
            right: 0,
        },
    });

interface PoolMenuItemProps extends WithStyles<typeof styles> {
    icon?: ReactNode;
    iconPosition?: 'left' | 'right';
    isSubMenu?: boolean;
    title: ReactNode;
    isExtendedMenu?: boolean;
    onClick?: (event: MouseEvent<HTMLElement>) => void;
    selected?: boolean;
    disabled?: boolean;
}

export const PoolMenuItem = withStyles(styles)(
    class PoolMenuItemBase extends Component<PoolMenuItemProps> {
        public override render() {
            const { title, classes, isSubMenu, isExtendedMenu, selected, disabled } = this.props;
            let { iconPosition, icon } = this.props;

            iconPosition = iconPosition ?? 'left';
            icon = typeof icon === 'string' ? <Icon className={icon + ' ' + classes.menuItemIcon} /> : icon;

            return (
                <MenuItem onClick={this.props.onClick} selected={selected} disabled={disabled}>
                    {icon && iconPosition === 'left' && <ListItemIcon>{icon}</ListItemIcon>}
                    <PoolTypography typography={isExtendedMenu ? 'caption' : 'body1'} component="span">
                        {typeof title === 'string' ? <FormattedMessage id={title} /> : title}
                    </PoolTypography>
                    {icon && iconPosition === 'right' && (
                        <ListItemIcon className={classes.iconRight}>{icon}</ListItemIcon>
                    )}
                    {isSubMenu && <ChevronRight className={classes.chevron} />}
                </MenuItem>
            );
        }
    }
);
